import styled from 'styled-components';

const Container = styled.div.attrs({ className: "section-header"})`
    width: 100%;
    height: 14rem;
    display: flex;
    justify-content: flex-start;
    align-items: end;
    background: transparent;
    color: var(--black);
    box-sizing: border-box;
    padding: 0 0;
    margin-bottom: 2rem;

    h2 {
        font-size: 1.2rem;
        padding: 1rem 2rem;
        border: 1px solid var(--border);
        border-radius: 999px;
        background: var(--white);
        box-shadow: var(--shadow-soft);
    }

    @media screen and (max-width: 650px) {
        justify-content: center;
    }
`

export default function SectionHeader({title, id}) {
    return (
        <Container id={id} >

            <h2> {title} </h2>

        </Container>
    )
}